import { types } from "mobx-state-tree";
export const DemoClassModel = types
    .model("DemoClass", {
    id: types.string,
    name: types.string,
});
export const DemoModel = types
    .model("Demo", {
    class: DemoClassModel,
    problemOrdinal: types.maybeNull(types.string),
    problemIndex: 0,
    name: ""
})
    .actions((self) => {
    return {
        setProblemOrdinal(problemOrdinal) {
            self.problemOrdinal = problemOrdinal;
        },
        setProblemIndex(problemIndex) {
            self.problemIndex = problemIndex;
        },
        setClass(id, name) {
            self.class.id = id;
            self.class.name = name;
        },
        setName(name) {
            self.name = name;
        }
    };
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGVtby5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9tb2RlbHMvc3RvcmVzL2RlbW8udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLEtBQUssRUFBRSxNQUFNLGlCQUFpQixDQUFDO0FBRXhDLE1BQU0sQ0FBQyxNQUFNLGNBQWMsR0FBRyxLQUFLO0tBQ2hDLEtBQUssQ0FBQyxXQUFXLEVBQUU7SUFDbEIsRUFBRSxFQUFFLEtBQUssQ0FBQyxNQUFNO0lBQ2hCLElBQUksRUFBRSxLQUFLLENBQUMsTUFBTTtDQUNuQixDQUFDLENBQUM7QUFFTCxNQUFNLENBQUMsTUFBTSxTQUFTLEdBQUcsS0FBSztLQUMzQixLQUFLLENBQUMsTUFBTSxFQUFFO0lBQ2IsS0FBSyxFQUFFLGNBQWM7SUFDckIsY0FBYyxFQUFFLEtBQUssQ0FBQyxTQUFTLENBQUMsS0FBSyxDQUFDLE1BQU0sQ0FBQztJQUM3QyxZQUFZLEVBQUUsQ0FBQztJQUNmLElBQUksRUFBRSxFQUFFO0NBQ1QsQ0FBQztLQUNELE9BQU8sQ0FBQyxDQUFDLElBQUksRUFBRSxFQUFFO0lBQ2hCLE9BQU87UUFDTCxpQkFBaUIsQ0FBQyxjQUFzQjtZQUN0QyxJQUFJLENBQUMsY0FBYyxHQUFHLGNBQWMsQ0FBQztRQUN2QyxDQUFDO1FBQ0QsZUFBZSxDQUFDLFlBQW9CO1lBQ2xDLElBQUksQ0FBQyxZQUFZLEdBQUcsWUFBWSxDQUFDO1FBQ25DLENBQUM7UUFDRCxRQUFRLENBQUMsRUFBVSxFQUFFLElBQVk7WUFDL0IsSUFBSSxDQUFDLEtBQUssQ0FBQyxFQUFFLEdBQUcsRUFBRSxDQUFDO1lBQ25CLElBQUksQ0FBQyxLQUFLLENBQUMsSUFBSSxHQUFHLElBQUksQ0FBQztRQUN6QixDQUFDO1FBQ0QsT0FBTyxDQUFDLElBQVk7WUFDbEIsSUFBSSxDQUFDLElBQUksR0FBRyxJQUFJLENBQUM7UUFDbkIsQ0FBQztLQUNGLENBQUM7QUFDSixDQUFDLENBQUMsQ0FBQyJ9